module.exports = __webpack_public_path__ + "static/media/27-6.271cd9cc.mp3";